import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import HelpIcon from 'dashboard/components-lib/HelpIcon';
import { formatDate } from 'dashboard/lib/utils/formatters';
import { Inquiry } from 'dashboard/models/inquiry';
import Card from 'design-system/components/Card';
import Spacer from 'design-system/components/Spacer';

interface InquiryReusablePersonasProps {
  inquiry: Inquiry;
}

const InquiryReusablePersonas = ({ inquiry }: InquiryReusablePersonasProps) => {
  const {
    'created-at': createdAt,
    'latest-authentication-verify-at': latestAuthenticationVerifyAt,
    'num-inquiries': numInquiries,
    'num-unique-ip-addresses': numUniqueIpAdddresses,
  } = inquiry.attributes['reusable-persona-risk-signals'];

  return (
    <Card>
      <Card.Body>
        <Card.Title>Reusable Persona</Card.Title>
        <Spacer height={1.5} width={2.5} />
        <AttributeGrid>
          {numUniqueIpAdddresses && (
            <AttributeItem title='Number of unique IP addresses' value={numUniqueIpAdddresses} />
          )}
          {latestAuthenticationVerifyAt && (
            <AttributeItem
              title={
                <>
                  Last used at
                  <HelpIcon>When the Persona was last successfully used in an inquiry</HelpIcon>
                </>
              }
              value={formatDate(latestAuthenticationVerifyAt)}
            />
          )}
          {numInquiries && (
            <AttributeItem title='Number of unique inquiries' value={numInquiries} />
          )}
          {createdAt && <AttributeItem title='Created at' value={formatDate(createdAt)} />}
        </AttributeGrid>
      </Card.Body>
    </Card>
  );
};

export default InquiryReusablePersonas;
